import React, { Component } from 'react';
import { JqueryClassFaker } from './JqueryClassFaker';

export default class Input extends Component {

	constructor(props) {
		super(props);

	}

	componentDidMount() {
		M.updateTextFields();
	}


	render() {
		const { className } = this.props;
		const classes = new JqueryClassFaker(className);
		if(this.props.value !== '') {
			classes.add('active');
		}
		return <input
			{...this.props}
			className={classes.toString()}
		/>;
	}
}
Input.instances = 1;